import { useMemo } from 'react';

import { useSession } from 'modules/accounts/hooks/useSession';
import { useGetCreditCardQuery, useGetOrganizationCreditCardQuery } from 'store/api';

export function useCreditCard() {
  const { session } = useSession();
  const isOrgContext = !!session?.organization;

  const personal = useGetCreditCardQuery(undefined, { skip: isOrgContext });
  const org = useGetOrganizationCreditCardQuery(undefined, { skip: !isOrgContext });

  const { data, isLoading, isSuccess, ...query } = isOrgContext ? org : personal;

  return useMemo(
    () => ({ creditCard: data ?? undefined, isCardLoading: isLoading, isSuccess, ...query }),
    [data, isLoading, isSuccess, query],
  );
}
